import { KalkulatorResultComponent } from './kalkulator-result.component';
export const KalkulatorResultModule = angular
	.module('kalkulatorResult', [])
	.component('kalkulatorResult', KalkulatorResultComponent)
	.name;




// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator-result/kalkulator-result.module.js